import { render, staticRenderFns } from "./MainMenuMobile.vue?vue&type=template&id=f889f9e4&"
import script from "./MainMenuMobile.vue?vue&type=script&lang=js&"
export * from "./MainMenuMobile.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuMobile.vue?vue&type=style&index=0&id=f889f9e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports